import { useGetWidgetSettingsListWidgetSettingsListGetQuery } from '@shared/api';
import { useAppSelector } from '@shared/redux';
import { authSelectors } from '@shared/redux/ducks/auth';

export const useGetPresets = () => {
  const organizationId = useAppSelector(authSelectors.selectCurrentOrganizationId);
  const query = useGetWidgetSettingsListWidgetSettingsListGetQuery(
    { organizationId: organizationId ?? 0 },
    { skip: !organizationId },
  );

  return {
    presets: query.data ?? [],
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    isError: query.isError,
    refetch: query.refetch,
  };
};
